module.exports = __webpack_public_path__ + "img/44.faf25de5.png";